<template>
  <modal name="dialogue-modal" height="auto" :adaptive="true">
    <div class="app-modal">
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-row align-items-center mb-2">
          <Logo/>
          <h1 class="ml-2 mb-0">{{title}}</h1>
        </div>
      </div>
      <div class="d-flex flex-row">
        <h2 class="modal-subtitle mb-4 mx-auto">{{subtitle}}</h2>
      </div>
      <div class="d-flex justify-content-around ml-4 mr-4">
        <button class="primary" width="auto" v-on:click="onOk">OK</button>
      </div>
    </div>
  </modal>
</template>

<script>
import Logo from '../components/Logo.vue'

export default {
  data: function () {
    return {
      title: null,
      subtitle: null
    }
  },
  components: {
    Logo
  },
  name: 'dialogue',
  mounted () {
    this.$store.subscribe(function (mutation, state) {
      switch (mutation.type) {
        case 'showDialogue':
          this.$modal.show('dialogue-modal')
          this.title = this.$store.state.dialogueTitle
          this.subtitle = this.$store.state.dialogueSubtitle
          break
        case 'hideDialogue':
          this.$modal.hide('dialogue-modal')
          break
      }
    }.bind(this))
  },
  methods: {
    onOk () {
      this.$store.commit('hideDialogue')
      this.$modal.hide('dialogue-modal')
    }
  }
}
</script>

<style scoped></style>
